import React, { useState } from 'react'
import Field from '../../common/FormField'
import PasswordStrengthRules from '../../common/PasswordStrengthRules'

export default function AccountForm(props) {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  // Destructure in render section below
  const togglePassword = () => setShowPassword(v => !v)
  const toggleConfirmPassword = () => setShowConfirmPassword(v => !v)

  const { data, error = {}, onChangeFactory, disabled, showUsername } = props

  return (
    <fieldset>
        {showUsername && (
          <Field
            type="input"
            name="Email *"
            note="You must visit your Account Settings to change your email."
            error={error.username}
          >
            <input
              type="email"
              placeholder="Enter the email address"
              value={data.username}
              onChange={onChangeFactory('username')}
              disabled={disabled}
            />
          </Field>
        )}

        <Field type="input" name="Password *" error={error.password}>
          <div style={{ position: 'relative' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter the password"
              value={data.password}
              onChange={onChangeFactory('password')}
              disabled={disabled}
            />
            <span
              onClick={togglePassword}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#555',
                userSelect: 'none',
              }}
            >
              <i className={`fa fa-lg ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
            </span>
          </div>
        </Field>
        <PasswordStrengthRules password={data.password} />

        <Field type="input" name="Confirm Password *" error={error.verifyPassword}>
          <div style={{ position: 'relative' }}>
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="Enter the password again"
              value={data.verifyPassword}
              onChange={onChangeFactory('verifyPassword')}
              disabled={disabled}
            />
            <span
              onClick={toggleConfirmPassword}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#555',
                userSelect: 'none',
              }}
            >
              <i className={`fa fa-lg ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
            </span>
          </div>
        </Field>

        <Field type="toggle">
          <input
            type="checkbox"
            checked={data.verified}
            onChange={onChangeFactory('verified')}
            disabled={disabled}
          />
          <i data-swchon-text="ON" data-swchoff-text="OFF" />
          Verified Seller?
        </Field>

        {data.verified && (
          <Field type="input" name="Platform Fee (%)" error={error.appFee}>
            <input
              type="text"
              placeholder="Enter the platform fee, e.g. enter 2.5 for 2.5% platform fee."
              value={data.appFee}
              onChange={onChangeFactory('appFee')}
              disabled={disabled}
            />
          </Field>
        )}
      </fieldset>
    )
}

